export const _supportedWidgetTypes = [
  "WidgetIssueOverview",
  "WidgetNote",
  "WidgetRoutineOverview",
  "WidgetRoutinePositivePercentage",
  "WidgetSignalOverview",
  "WidgetTaskCollection",
  "WidgetTaskMultiple",
  "WidgetTaskSingle",
  "WidgetTodoOverview",
  "WidgetTodoSummary",
  "WidgetIntegrationIpool",
  "WidgetIntegrationPushAppy",
  "WidgetWeather",
  "WidgetTeamSchedule",
  "WidgetEmployeeSchedule",
  "WidgetEmployeeLeave",
  "WidgetIssueSummary",
  "WidgetIntegrationTurnpike",
  "WidgetCalendar",
  "WidgetFile",
  "WidgetIntegrationFlourishPraise",
  "WidgetSpace",
  "WidgetKPI",
  "WidgetNewsfeed",
  "WidgetList",
  "WidgetTable",
  "WidgetCalendarOverview",
  "WidgetEmployeeRoleOverview",
] as const;

export const supportedWidgetTypes = _supportedWidgetTypes as readonly string[];
